import { render, staticRenderFns } from "./sport-column-banners.vue?vue&type=template&id=3fd131b6"
import script from "./sport-column-banners.vue?vue&type=script&lang=js"
export * from "./sport-column-banners.vue?vue&type=script&lang=js"
import style0 from "./sport-column-banners.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/sport-column-banners.vue
// module id = L+fI
// module chunks = 0